import React from 'react';
import { Link } from 'react-router-dom';
import './GameSwitcher.css';

const GAMES = [
  { to: '/zip', label: 'Zip Game', emoji: '🧩' },
  { to: '/neon', label: 'Neon Breaker', emoji: '🧱' },
  { to: '/jelly', label: 'Jelly Match', emoji: '🍬' },
];

const GameSwitcher = () => (
  <div className="game-switcher-screen">
    <h1>Game Admin Portal</h1>
    <p>Pick a game to manage. Each game signs in separately with its own admin account.</p>
    <div className="game-switcher-grid">
      {GAMES.map((game) => (
        <Link key={game.to} to={game.to} className="game-switcher-card">
          <span className="game-switcher-emoji">{game.emoji}</span>
          <span>{game.label}</span>
        </Link>
      ))}
    </div>
  </div>
);

export default GameSwitcher;
